function burger() {

  /*
  ** ==================== controller
  */
  let deployed = false
  function updateNav() {
    deployed = !deployed
    document.documentElement.classList.toggle('nav-deployed', deployed)
    window.preventScrollNav = deployed
    toggle()
  }
  function forceNavLeave() {
    if (deployed) {
      deployed = false
      document.documentElement.classList.remove('nav-deployed')
      window.preventScrollNav = false
      toggle()
    }
  }

  /*
  ** ==== anim
  */
  function toggle() {
    if (deployed) {
      open()
    } else {
      close()
    }
  }

  function open() {}

  function close() {}

  /*
  ** ==================== events
  */

  document.addEventListener('click', (e) => {
    if (e.target.closest('.burger')) {
      updateNav()
    }
  })

  if (typeof bus !== 'undefined') {
    bus.on('pageLeave', forceNavLeave)
  }

  // updateNav() // debug

}

export default burger
